import Vue from 'vue';
import Router from 'vue-router';
import PageNotFound from '@/pages/PageNotFound';
import DashboardPage from '@/pages/DashboardPage';
import Styleguide from '@/pages/Styleguide';
import AuthenticationPage from '@/pages/AuthenticationPage';
import AnnualReportPage from '../pages/AnnualReportPage';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: {name: 'dashboard'}
        },
        {
            // Vue-router supports regex: ':paramName(regex)' (double backslash because it is in a string
            // Regex source: https://stackoverflow.com/questions/22061723/regex-date-validation-for-yyyy-mm-dd/22061800
            path: '/dashboard/:start(\\d{4}\\-\\d{2}\\-\\d{2})?/:end(\\d{4}\\-\\d{2}\\-\\d{2})?',
            name: 'dashboard',
            component: DashboardPage,
            meta: {
                auth: true,
            }
        },
        {
            path: '/report/annual',
            name: 'annualreport',
            component: AnnualReportPage,
            meta: {
                auth: true,
            }
        },
        {
            path: '/auth',
            name: 'sign-in',
            component: AuthenticationPage,
        },
        {
            path: '/styleguide',
            name: 'styleguide',
            component: Styleguide,
            meta: {
                debugRoute: true,
            }
        },
        {
            path: '/page-not-found',
            name: 'PageNotFound',
            component: PageNotFound
        },
        {
            path: '**',
            redirect: '/page-not-found'
        }
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta !== undefined && to.meta.auth) {
        //Check if user is signed in. Route requires sign in.
        if (Vue.prototype.$auth.currentUser() === null) {
            next({
                name: 'sign-in',
                query: {
                    redirect: to.path
                }
            });
            return;
        }
    }
    next();
});

/**
 * Disable debug routes (stylesheet, etc) on production
 */
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.debugRoute)) {
        if (!Vue.prototype.$config.debug) {
            next({ path: '/' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js